import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { RouterModule } from "@angular/router";
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CpfCnpjPipe } from './pipes/cpfCnpj.pipe';
import { EmptyDashPipe } from './pipes/empty-dash.pipe';

@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NzIconModule,
        SearchPipe,
        NzMessageModule,
        CpfCnpjPipe,
        EmptyDashPipe
    ],
    imports: [
        RouterModule,
        CommonModule,
        NzIconModule,
        NzToolTipModule,
        NzMessageModule
    ],
    declarations: [
        SearchPipe,
        CpfCnpjPipe,
        EmptyDashPipe
    ],
    providers: [
        ThemeConstantService,
        NzMessageService
    ]
})

export class SharedModule { }
